import * as React from 'react'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import PersonIcon from '@mui/icons-material/Person'
import ToggleButton from '@mui/material/ToggleButton'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'

import { HeaderSearchAssetType } from '../../enums/enums'

type ComponentProps = {
  value?: HeaderSearchAssetType | null
  onChange: (e: React.MouseEvent<HTMLElement>, value: HeaderSearchAssetType | null) => void
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  borderBottom: '1px solid #bdbdbd',
  width: '100%',
  borderRadius: 0,
  '& .MuiToggleButton-root': {
    border: 'none',
    padding: '9px 7px',
    color: '#bdbdbd',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'inherit',
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
  '& .MuiTypography-root': {
    fontSize: 14,
  },
  '& .MuiToggleButton-root.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: 'inherit',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  '& .MuiAutocomplete-noOptions': {
    padding: '10px',
    fontSize: 14,
    color: '#404041',
  },
}))

function HeaderSearchFilter(props: ComponentProps): JSX.Element {
  const { t } = useTranslation()
  const { value = false, onChange } = props

  return (
    <StyledToggleButtonGroup
      onMouseDown={(event) => {
        event.preventDefault()
      }}
      value={value}
      exclusive
      onChange={onChange}
      aria-label="text alignment"
    >
      <ToggleButton value={HeaderSearchAssetType.all} aria-label="left aligned">
        <Typography>{t('all')}</Typography>
      </ToggleButton>
      <ToggleButton value={HeaderSearchAssetType.prospects} aria-label="centered">
        <PersonIcon />
      </ToggleButton>
      <ToggleButton value={HeaderSearchAssetType.organizations} aria-label="right aligned">
        <BusinessOutlinedIcon />
      </ToggleButton>
      <ToggleButton value={HeaderSearchAssetType.deals} aria-label="justified">
        <AttachMoneyIcon />
      </ToggleButton>
    </StyledToggleButtonGroup>
  )
}

export default HeaderSearchFilter
